import { el, clear } from '../core/dom.js';
import { api } from '../core/api.js';
import { withProduct } from '../core/route-map.js';
import { openModal } from './modal.js';
import { skeleton } from './skeleton.js';
import { empty } from './empty.js';
import { errorPanel } from './error.js';

/**
 * Grouped search against the existing `/search?type=grouped` endpoint.
 * @param {{ productId?: string }} opts
 */
export function openSearch(opts) {
  const productId = opts.productId || '';
  const input = el('input', {
    class: 'search-input',
    type: 'search',
    placeholder: 'Search insights, chats, files, connectors',
    'aria-label': 'Search',
    autocomplete: 'off',
  });
  const results = el('div', { class: 'search-results' }, el('p', { class: 'menu-empty' }, 'Start typing'));
  let timer = 0;
  let dialog;
  input.addEventListener('input', () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(() => { run(input.value); }, 200);
  });
  dialog = openModal({
    title: 'Search',
    className: 'search-modal',
    body: el('div', { class: 'search-body' }, input, results),
  });
  input.focus();

  async function run(raw) {
    const query = String(raw || '').trim();
    clear(results);
    if (query.length < 2) {
      results.append(el('p', { class: 'menu-empty' }, 'Start typing'));
      return;
    }
    results.append(skeleton(3));
    const scope = productId ? `&product_id=${encodeURIComponent(productId)}` : '';
    const data = await api(`/search?type=grouped&q=${encodeURIComponent(query)}&limit=8${scope}`);
    clear(results);
    if (!data || data.error) {
      results.append(errorPanel({ title: 'Search failed', message: 'Try again in a moment.' }));
      return;
    }
    renderGroups(results, data.groups || {}, productId, () => dialog.close());
  }
}

function renderGroups(results, groups, productId, close) {
  const blocks = [
    ['Insights', groups.insights, (row) => row.headline, () => withProduct('/app/dashboard', productId)],
    ['Chats', groups.chats, (row) => row.title || row.snippet, (row) => withProduct(`/app/chat/${encodeURIComponent(row.id)}`, productId)],
    ['Knowledge', groups.documents, (row) => row.title, () => withProduct('/app/knowledge', productId)],
    ['Connectors', groups.connectors, (row) => row.provider_display || row.provider_name || row.label || 'Connector', () => withProduct('/app/connectors', productId)],
  ];
  let any = false;
  for (const [label, rows, labelOf, hrefOf] of blocks) {
    if (!rows || !rows.length) continue;
    any = true;
    results.append(el('p', { class: 'kicker' }, label));
    for (const row of rows) {
      results.append(el('a', { class: 'search-hit', href: hrefOf(row), onClick: close }, labelOf(row) || 'Result'));
    }
  }
  if (!any) results.append(empty({ title: 'No results', body: 'Try a different word.' }));
}
